import React, { Fragment } from 'react';
import { Column, Section, Title, Container, Card} from "rbx";
import "../../../styles/auth.scss";
import Header from "../../../components/components/Header";
import ForgotPasswordForm from '../../../components/auth/forgot_password_form';

const ForgotPasswordScreen = () => {

  return (
    <Fragment>
      <Header/>
      <Section size="small" className="auth">
        <Container>
          <Column.Group centered>
            <Column size={4}>
              <Card>
                <Card.Content>
                  <Section>
                    <Column.Group>
                      <Column size={12}>
                        <Title size={4} className="has-text-centered">
                          Redefinição de Senha!
                        </Title>
                        <ForgotPasswordForm />
                      </Column>
                    </Column.Group>
                  </Section>
                </Card.Content>
              </Card>
            </Column>
          </Column.Group>
        </Container>
      </Section>
    </Fragment>
  )

}

export default ForgotPasswordScreen;
